const uuid4 = require('uuid').v4;
const generateId = () => uuid4().replace(/-/g, '');

module.exports = generateId;
